import React, { useEffect, useRef, useState } from "react";
import { FaBriefcase, FaGraduationCap, FaMapMarkerAlt } from "react-icons/fa";
import { experiences } from "../../data/portfolioData";
import "./Experience.css";

const Experience = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="experience" id="experience" ref={sectionRef}>
      <div className="experience__container">
        <h2 className="section-title">Education</h2>
        <p className="section-subtitle">My academic journey</p>

        <div className="timeline">
          {experiences.map((exp, idx) => (
            <div
              key={exp.id}
              className={`timeline__item ${
                idx % 2 === 0 ? "timeline__item--left" : "timeline__item--right"
              } ${visible ? "animate-fade-up" : ""}`}
              style={{ animationDelay: `${idx * 0.15}s` }}
            >
              <div className="timeline__icon">
                {exp.type === "work" ? <FaBriefcase /> : <FaGraduationCap />}
              </div>
              <div className="timeline__card">
                <span className="timeline__date">
                  {exp.startDate} — {exp.endDate}
                </span>
                <h3 className="timeline__title">{exp.title}</h3>
                <h4 className="timeline__org">{exp.organization}</h4>
                <p className="timeline__location">
                  <FaMapMarkerAlt /> {exp.location}
                </p>
                <p className="timeline__desc">{exp.description}</p>
                <div className="timeline__tech">
                  {exp.technologies.map((tech) => (
                    <span key={tech} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
